import { Container } from '@mui/material';
import React, { Component } from 'react'
import { Redirect } from 'react-router-dom';
import Constantes from '../php/Constantes';


class Login extends Component {
    constructor(props){
        super(props);
        this.state = {
            errores: null,
            notificaciones: null,
            loginCorrecto: false,
            login: {
                password: '',
                numeroFuncionario: '',
            },
            primeraVez: false,
        }

        this.controlarCambios = this.controlarCambios.bind(this);
        this.manejarEnvioDatos = this.manejarEnvioDatos.bind(this);
    }

    async componentDidMount(){
        sessionStorage.removeItem('login');
        sessionStorage.setItem('sinLogin', true);
        //----------------------
        sessionStorage.removeItem('numeroFuncionario');
        sessionStorage.setItem('numeroFuncionario', '');
        sessionStorage.removeItem('tipoUsuario');
        sessionStorage.setItem('tipoUsuario', '');
        sessionStorage.removeItem('nombreFuncionario');
        sessionStorage.setItem('nombreFuncionario', '');
        sessionStorage.removeItem('lugar');
        sessionStorage.setItem('lugar', '');
        sessionStorage.removeItem('lugarCentral');
        sessionStorage.setItem('lugarCentral', '');
        sessionStorage.removeItem('numeroFuncionarioAsociado');
        sessionStorage.setItem('numeroFuncionarioAsociado', '');
        sessionStorage.removeItem('primeraVez');
        sessionStorage.setItem('primeraVez', '');
        sessionStorage.removeItem('fotoPerfil');
        sessionStorage.setItem('fotoPerfil', '');
        //----------------------
    }

    render(){
        return (
            <>
            {sessionStorage.login
            ?
                <Redirect to='/inicio'/>
                //<Redirect to='/Consultas'/>
            :
                <Container>
                    <div className='mt-5'>
                        <h3 className='text-center'>Login</h3>
                        <hr />
                        <div className='row justify-content-center'>
                            <div className="col-12 col-sm-8 col-md-6 col-xl-4">
                                <form onSubmit={this.manejarEnvioDatos}>
                                    {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                                    {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                                    <input type="text" className='form-control mb-2'  placeholder='INGRESE USUARIO' id='numeroFuncionario' onChange={this.controlarCambios} value={this.state.login.numeroFuncionario}/>
                                    <input type="password" className='form-control mb-2' placeholder='INGRESE PASSWORD' id='password' onChange={this.controlarCambios} value={this.state.login.password}/>
                                    <button className='btn btn-outline-dark btn-lg btn-block'>Aceptar</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </Container>
            }
            {/*this.state.loginCorrecto
            ?
                this.state.primeraVez
                ?
                    <Redirect to='/personal-app/primera-vez'/>
                :
                    <Redirect to='/personal-app/ini'/>
            :
                null
            */}
            {
                this.state.loginCorrecto
                ?
                    <Redirect to='/personal-app/ini'/>
                :
                    null
            }
            </>
        )
    }

    controlarCambios(e) {
        e.preventDefault()
        
        this.setState({
            errores: null,
            notificaciones: null,
        })
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const loginActualizado = state.login;
            loginActualizado[clave] = valor;
            return{
                login: loginActualizado,
            };
        })
    }

    async manejarEnvioDatos(e){
        e.preventDefault()
        if(this.state.login.numeroFuncionario === ''){
            this.setState({
                errores: 'Debe ingresar un nombre de usuario!'
            });
        }else if(this.state.login.password === ''){
            this.setState({
                errores: 'Debe ingresar una contraseña!'
            });
        }else{
            const cargaUtil = JSON.stringify(this.state.login);

            const respuesta = await fetch(`${Constantes.RUTA_API}/validar_login.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();

            if(exito){
                if(exito.length !== 0){
                    if(exito.login){
                        sessionStorage.removeItem('login');
                        sessionStorage.removeItem('sinLogin');
                        //----------------------
                        sessionStorage.removeItem('numeroFuncionario');
                        sessionStorage.removeItem('tipoUsuario');
                        sessionStorage.removeItem('nombreFuncionario');
                        sessionStorage.removeItem('lugar');
                        sessionStorage.removeItem('lugarCentral');
                        sessionStorage.removeItem('numeroFuncionarioAsociado');
                        sessionStorage.removeItem('primeraVez');
                        sessionStorage.removeItem('escalafon');
                        sessionStorage.removeItem('fotoPerfil');
                        sessionStorage.removeItem('presupuestado');
                        //----------------------
                        sessionStorage.setItem('numeroFuncionario', exito.numeroFuncionario);
                        sessionStorage.setItem('tipoUsuario', exito.tipoUsuario);
                        sessionStorage.setItem('nombreFuncionario', exito.nombreFuncionario);
                        sessionStorage.setItem('login', exito.login);
                        sessionStorage.setItem('lugar', exito.lugar);
                        sessionStorage.setItem('lugarCentral', exito.lugarCentral);
                        sessionStorage.setItem('numeroFuncionarioAsociado', exito.numeroFuncionarioAsociado);
                        sessionStorage.setItem('primeraVez', exito.primeraVez);
                        sessionStorage.setItem('escalafon', exito.escalafon);
                        sessionStorage.setItem('fotoPerfil', exito.fotoPerfil);
                        sessionStorage.setItem('sinLogin', false);
                        sessionStorage.setItem('presupuestado', exito.presupuestado);

                        this.setState({
                            loginCorrecto: exito.login,
                        })
                        if(exito.primeraVez === 0){
                            this.setState({
                                primeraVez: false,
                            })
                        }else{
                            this.setState({
                                primeraVez: true,
                            })
                        }
                    }else{
                        this.setState({
                            errores: 'Usuario o contraseña incorrecta',
                        })
                    }
                }else{
                    this.setState({
                        errores: 'No hay nada papu',
                    })
                }
            }
        }
    }
}

export default Login